module.exports = __webpack_public_path__ + "static/sdk-text-29cd4fe7ff37898a56c547d254da3371.gif";